import { createReactRouterBasedAdapter } from './chunk-KDNOHZGV.js';
import { createAdapterProvider } from './chunk-DASHEO2X.js';
import { useNavigate, useSearchParams } from 'react-router-dom';

var {
  enableHistorySync,
  useNuqsReactRouterBasedAdapter: useNuqsReactRouterV6Adapter,
  useOptimisticSearchParams
} = createReactRouterBasedAdapter(
  "react-router-v6",
  useNavigate,
  useSearchParams
);
var NuqsAdapter = createAdapterProvider(useNuqsReactRouterV6Adapter);
enableHistorySync();

export { NuqsAdapter, useOptimisticSearchParams };
